
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Error404 from '../Pages/Error404';
import {
  Login,
  Dashboard,
  Faculty,
  FacultyAdd,
  FacultyEdit,
  Discipline,
  DisciplineAdd,
  DisciplineEdit,
  Specialization,
  SpecializationAdd,
  SpecializationEdit,
  Users,
  Viewlog,
  Course,
  CourseAdd,
  CourseEdit,
  CourseView,
  Permissions,
  Roles,
  RolebyPermission,
  MapPermission,
  AssignRole,
  Pathway,
  Coursemapping,
  AddRole,
  AddPermission,
  CourseDisciplineAEC_MappingAdd,
  CourseDisciplineAEC_Mapping,
  CourseDisciplineAEC_MappingEdit,
  Syllabus,
  CollegeSeatMapping,
  CollegeUserSeatMapping,
  AddUsers,

  Admin_ACA16SignatureCourseList,
  Admin_BOSReccSignatureCourseList,
  ACA16_ExternalCreditApprovalList,
  AddExpertCommitteeConvenor,
  ExpertCommitteeConvenorList,
  EditExpertCommitteeConvenor,
  ACA16_IPOVendorlist,
  ACA16_UserCreate,

  AdminChangePassword,
  AdminImpersonation,
  CollegeLevelEventList,
  CollegeLevelEventsAdd,
  CollegeLevelEventsEdit,
  UpdateEventList,
  UpdateEvents,
  TimeTable,

  CondonationSection,
  ACA16_IPOUniversityVendorlist

} from '../Pages/Admin';

import {
  Bvoc_Course,
  Bvoc_CourseAdd,
  Bvoc_CourseView,
  Bvoc_CourseEdit,
  Admin_ACA12SignatureCourseList,
  Admin_RecSignatureCourseList,

} from '../Pages/Admin/ACA12';

import ProtectedRoute from '../component/ProtectedRoute';

const AdminRoutes = () => (

  <Routes>

    <Route path="/*" element={<Error404 />} />
    <Route path="/" element={<Login />} />
    <Route path="/AdminImpersonation" element={<ProtectedRoute element={<AdminImpersonation />} role={1} />} />
    <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} role={1} />} />
    <Route path="/faculty" element={<ProtectedRoute element={<Faculty />} role={1} />} />
    <Route path="/facultyadd" element={<ProtectedRoute element={<FacultyAdd />} role={1} />} />
    <Route path="/facultyedit/:id" element={<ProtectedRoute element={<FacultyEdit />} role={1} />} />
    <Route path="/discipline" element={<ProtectedRoute element={<Discipline />} role={1} />} />
    <Route path="/disciplineadd" element={<ProtectedRoute element={<DisciplineAdd />} role={1} />} />
    <Route path="/disciplineedit/:id" element={<ProtectedRoute element={<DisciplineEdit />} role={1} />} />
    <Route path="/specialization" element={<ProtectedRoute element={<Specialization />} role={1} />} />
    <Route path="/specializationadd" element={<ProtectedRoute element={<SpecializationAdd />} role={1} />} />
    <Route path="/specializationedit/:id" element={<ProtectedRoute element={<SpecializationEdit />} role={1} />} />
    <Route path="/users" element={<ProtectedRoute element={<Users />} role={1} />} />
    <Route path="/userslog/:id" element={<ProtectedRoute element={<Viewlog />} role={1} />} />
    <Route path="/course" element={<ProtectedRoute element={<Course />} role={1} />} />
    <Route path="/courseadd" element={<ProtectedRoute element={<CourseAdd />} role={1} />} />
    <Route path="/courseedit/:id/:semid" element={<ProtectedRoute element={<CourseEdit />} role={1} />} />
    <Route path="/courseview/:id" element={<ProtectedRoute element={<CourseView />} role={1} />} />
    <Route path="/permissions" element={<ProtectedRoute element={<Permissions />} role={1} />} />
    <Route path="/roles" element={<ProtectedRoute element={<Roles />} role={1} />} />
    <Route path="/rolebypermission/:rolename" element={<ProtectedRoute element={<RolebyPermission />} role={1} />} />
    <Route path="/mappermission/:rolename" element={<ProtectedRoute element={<MapPermission />} role={1} />} />
    <Route path="/assignroles/:id" element={<ProtectedRoute element={<AssignRole />} role={1} />} />
    <Route path="/pathway" element={<ProtectedRoute element={<Pathway />} role={1} />} />
    <Route path="/coursemapping" element={<ProtectedRoute element={<Coursemapping />} role={1} />} />
    <Route path="/addrole" element={<ProtectedRoute element={<AddRole />} role={1} />} />
    <Route path="/addpermission" element={<ProtectedRoute element={<AddPermission />} role={1} />} />
    <Route path="/coursedisciplineAECmappingadd" element={<ProtectedRoute element={<CourseDisciplineAEC_MappingAdd />} role={1} />} />
    <Route path="/coursedisciplineAECmapping" element={<ProtectedRoute element={<CourseDisciplineAEC_Mapping />} role={1} />} />
    <Route path="/coursedisciplineAECmappingedit/:id" element={<ProtectedRoute element={<CourseDisciplineAEC_MappingEdit />} role={1} />} />
    <Route path="/syllabus" element={<ProtectedRoute element={<Syllabus />} role={1} />} />

    {/* <Route path="/adminaca16signaturecourse" element={<ProtectedRoute element={<Admin_ACA16SignatureCourseList />} role={1} />} /> */}
    {/* <Route path="/adminbosreccsignaturecourse" element={<ProtectedRoute element={<Admin_BOSReccSignatureCourseList />} role={1} />} /> */}

    <Route path="/adminChangePassword" element={<ProtectedRoute element={<AdminChangePassword />} role={1} />} />
    <Route path="/updateevents" element={<ProtectedRoute element={<UpdateEvents />} role={1} />} />
    <Route path="/updateeventlist" element={<ProtectedRoute element={<UpdateEventList />} role={1} />} />
    <Route path="/collegeleveleventlist" element={<ProtectedRoute element={<CollegeLevelEventList />} role={1} />} />
    <Route path="/collegeleveleventsadd" element={<ProtectedRoute element={<CollegeLevelEventsAdd />} role={1} />} />
    <Route path="/collegeleveleventsedit/:id" element={<ProtectedRoute element={<CollegeLevelEventsEdit />} role={1} />} />
    {/* <Route path="/aca16externalcreditapprovallist" element={<ProtectedRoute element={<ACA16_ExternalCreditApprovalList />} role={1} />} /> */}

    {/* ACA-16 */}
    <Route path="/adminaca16signaturecourse" element={<ProtectedRoute element={<Admin_ACA16SignatureCourseList />} role={1} />} />
    <Route path="/adminbosreccsignaturecourse" element={<ProtectedRoute element={<Admin_BOSReccSignatureCourseList />} role={1} />} />
    <Route path="/aca16externalcreditapprovallist" element={<ProtectedRoute element={<ACA16_ExternalCreditApprovalList />} role={1} />} />
   
    <Route path="/aca16ipovendorlist" element={<ProtectedRoute element={<ACA16_IPOVendorlist />} role={1} />} />
    <Route path="/aca16_usercreate" element={<ProtectedRoute element={<ACA16_UserCreate />} role={1} />} />
    <Route path="/aca16_useredit/:id" element={<ProtectedRoute element={<ACA16_UserCreate />} role={1} />} />
    <Route path="/aca16ipoUniversityvendorlist" element={<ProtectedRoute element={<ACA16_IPOUniversityVendorlist />} role={1} />} />
    

    {/* ACA-16 End */}
    
    {/* itecell */}
    <Route path="/collegeseatmapping" element={<ProtectedRoute element={<CollegeSeatMapping />} role={1} />} />
    <Route path="/collegeuserseatmapping" element={<ProtectedRoute element={<CollegeUserSeatMapping />} role={1} />} />
    <Route path="/addusers" element={<ProtectedRoute element={<AddUsers />} role={1} />} />
    {/* itecell End */}


    {/* ACA-12 */}
    <Route path="/bvoc_course" element={<ProtectedRoute element={<Bvoc_Course />} role={1} />} />
    <Route path="/bvoc_courseadd" element={<ProtectedRoute element={<Bvoc_CourseAdd />} role={1} />} />
    <Route path="/bvoc_courseview/:id" element={<ProtectedRoute element={<Bvoc_CourseView />} role={1} />} />
    <Route path="/bvoc_courseedit/:id/:semid" element={<ProtectedRoute element={<Bvoc_CourseEdit />} role={1} />} />
    <Route path="/adminaca12signaturecourse" element={<ProtectedRoute element={<Admin_ACA12SignatureCourseList />} role={1} />} />
    <Route path="/adminrecsignaturecourse" element={<ProtectedRoute element={<Admin_RecSignatureCourseList />} role={1} />} />
    {/* ACA-12 End */}
    {/* Expert Committee Convenor */}
    <Route path="/addexpertcommitteeconvenor" element={<ProtectedRoute element={<AddExpertCommitteeConvenor />} role={1} />} />
    <Route path="/expertcommitteeconvenorlist" element={<ProtectedRoute element={<ExpertCommitteeConvenorList />} role={1} />} />
    <Route path="/editexpertcommitteeconvenor/:id" element={<ProtectedRoute element={<EditExpertCommitteeConvenor />} role={1} />} />

    {/*---------------------------- Time Table ----------------------------------------------*/}
    <Route path="/time-table" element={<ProtectedRoute element={<TimeTable />} role={1} />} />
    {/*---------------------------- Time Table ----------------------------------------------*/}


  {/*---------------------------- Condonation ----------------------------------------------*/}
    <Route path="/CondonationSection" element={<ProtectedRoute element={<CondonationSection />} role={1} />} />


  </Routes>

);

export default AdminRoutes;

